var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.9948 22.3018V22.3009H23.0004V14.1217C23.0004 10.1204 22.139 7.03809 17.4612 7.03809C15.2124 7.03809 13.7033 8.27212 13.0872 9.44203H13.0222V7.41164H8.58691V22.3009H13.2052V14.9283C13.2052 12.9871 13.5732 11.11 15.9772 11.11C18.3458 11.11 18.3811 13.3253 18.3811 15.0528V22.3018H22.9948Z",
    fill: "#81909E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.06641 7.41211H5.69031V22.3013H1.06641V7.41211Z",
    fill: "#81909E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.37631 0C1.89789 0 0.698242 1.19965 0.698242 2.67807C0.698242 4.15649 1.89789 5.38123 3.37631 5.38123C4.85474 5.38123 6.05439 4.15649 6.05439 2.67807C6.05346 1.19965 4.85381 0 3.37631 0V0Z",
    fill: "#81909E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.81bae7f0f3be0def691265a8866c08dd.svg";
export { ForwardRef as ReactComponent };